import { useEffect } from "react";

export const useEscapeById = (id: string, depId?: string) => {
    const onEscape = (event: KeyboardEvent) => {
		if (event.key == "Escape") {
			event.preventDefault();
			event.stopPropagation();

            if (depId && document.getElementById(depId)?.hasChildNodes()) {
                return;
            }

            const modal = document.getElementById(id);

            if (modal && modal?.hasChildNodes()) {
                document.getElementById(id)?.click();
            }

		}
	}

	useEffect(() => {
		document.addEventListener('keydown', onEscape);

		return () => document.removeEventListener('keydown', onEscape);
		//eslint-disable-next-line
	}, []);
}